import getHelixScoreBand from './getHelixScoreBand';

/**
 * The band a score from the analysis endpoints falls in, under one view's display settings - or
 * null when that view doesn't show bands. Works for raw scores and for scores normalised to
 * their bands' positions, which is how the endpoints send them when bands are shown but scores
 * aren't. Components get it for the view they're shown in from `useViewerScoreBand`.
 * @param score - The score, as the API returned it
 * @param displaySettings - The view's display settings, from `getHelixUIMode`
 * @returns The band, or null
 */
export default function getViewerScoreBand(score, displaySettings) {
  var showScoreBands = displaySettings.showScoreBands,
    scoreBands = displaySettings.scoreBands,
    scoresNormalisedToBands = displaySettings.scoresNormalisedToBands;
  if (!showScoreBands) {
    return null;
  }
  return getHelixScoreBand(score, {
    scoreBands: scoreBands,
    normalised: scoresNormalisedToBands
  });
}